import { Swiper, SwiperSlide } from 'swiper/react'
import { EffectCards } from 'swiper/modules'

import CompanyCard from './CompanyCard'
import useWindowWidth from '../../../../../hooks/useWindowWidth'

import style from './style.module.css'
import 'swiper/css'
import 'swiper/css/effect-cards'
import './style.css'

const Companies = ({ companies, handleCompanyOpen }) => {
  const isMobile = useWindowWidth() <= 768

  return (
    <>
      {isMobile ? (
        <Swiper
          effect={'cards'}
          grabCursor={true}
          modules={[EffectCards]}
          className={style.companiesSwiper}
        >
          {companies.map((company) => (
            <SwiperSlide>
              <CompanyCard
                company={company}
                handleCompanyOpen={handleCompanyOpen}
              />
            </SwiperSlide>
          ))}
        </Swiper>
      ) : (
        <div className={style.companies}>
          {companies.map((company) => (
            <CompanyCard
              company={company}
              handleCompanyOpen={handleCompanyOpen}
            />
          ))}
        </div>
      )}
    </>
  )
}

export default Companies
